export const isAuthenticated = () => {
  if (
    localStorage.getItem("@ecorban-app:token") &&
    localStorage.getItem("@ecorban-app:token") !== null
  ) {
    return true;
  }
  return false;
};



// WEBPACK FOOTER //
// ./src/services/auth.js